import { groupLabel } from "../lib/format";

export const GroupPill = ({ cls, className = "" }) => {
  if (!cls)
    return (
      <span className={`group-pill group-c-none ${className}`} data-testid="group-pill-none">
        <span className="group-dot" />No group yet
      </span>
    );
  return (
    <span className={`group-pill group-c-${cls.color || "blue"} ${className}`} data-testid={`group-pill-${cls.id}`}>
      <span className="group-dot" />{groupLabel(cls)}
    </span>
  );
};
